import React from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { InventoryCostsSummary } from '../../services/inventoryCostsApi';

const COLORS: Record<string, string> = {
  mechanical: '#6366f1',
  cosmetics: '#ec4899',
  maintenance: '#14b8a6',
  other: '#f59e0b',
};
const LABELS: Record<string, string> = {
  mechanical: 'Mechanical',
  cosmetics: 'Cosmetics',
  maintenance: 'Pre-Sale Maintenance',
  other: 'Other',
};
const fmt = (n: number) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n);

interface Props {
  summary: InventoryCostsSummary;
  periodLabel: string;
}

export const CategoryBreakdownPie: React.FC<Props> = ({ summary, periodLabel }) => {
  const data = (Object.entries(summary.spent_by_category) as [string, string][])
    .map(([k, v]) => ({ name: LABELS[k] ?? k, key: k, value: Number(v) }))
    .filter((d) => d.value > 0);

  return (
    <div className="bg-white rounded-lg shadow border border-gray-200 p-4">
      <h3 className="text-lg font-medium mb-2">Spend by Category — {periodLabel}</h3>
      {data.length === 0 ? (
        <p className="text-gray-500 text-sm py-12 text-center">
          No expenses logged in this period.
        </p>
      ) : (
        <div style={{ width: '100%', height: 280 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={100}
                label={(d: any) => fmt(d.value)}
              >
                {data.map((d) => (
                  <Cell key={d.key} fill={COLORS[d.key] ?? '#9ca3af'} />
                ))}
              </Pie>
              <Tooltip formatter={(v: number) => fmt(v)} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default CategoryBreakdownPie;
